import React, { Component } from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import _actions from '../../actions';
import DragAndDrop from './dragAndDrop';
import constants from '../../constants';
import i18n from '../../i18n';

class ImageDropZone extends Component {
    constructor(props) {
        super(props);
        this.dropImage = this.dropImage.bind(this);
        this.handleChosenImage = this.handleChosenImage.bind(this);
        this.clearUpload = this.clearUpload.bind(this);
        this.state = {
            hasError: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.hasError && this.props.hasError) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ hasError: true });
        }
    }

    handleChosenFile = (file) => {
        if (!file) return;
        this.clearUploadWarnings();

        if ((file.type !== 'image/png') && (file.type !== 'image/jpg') && (file.type !== 'image/jpeg')) {
            this.fireTypeWarning();
            return;
        }
        if (file.size > 5120000) {
            this.fireFileSizeWarning();
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            this.props.setFile({ file });
        };

        this.props.actions.uploadAssetImageForCrop(
            this.props.match.params.projectId,
            constants.ImageType.find((n) => { return n.Name === this.props.imageType; }).Id,
            file,
        );

        reader.readAsDataURL(file);
    }

    handleChosenImage(incomingData) {
        this.handleChosenFile(incomingData);
    }

    fireTypeWarning = () => {
        this.props.actions.addAlert({
            message: i18n.t('logo.error2'),
            dismissable: true,
            type: 'error',
            view: this.props.alertView ? this.props.alertView : 'logo',
            id: this.props.alertView ? `${this.props.alertView}-upload-wrong-type` : 'logo-upload-wrong-type',
        });
        this.setState({ hasError: true });
    }

    fireFileSizeWarning = () => {
        this.props.actions.addAlert({
            message: i18n.t('logo.error3'),
            dismissable: true,
            type: 'error',
            view: this.props.alertView ? this.props.alertView : 'logo',
            id: this.props.alertView ? `${this.props.alertView}-upload-wrong-file-size` : 'logo-upload-file-size',
        });
        this.setState({ hasError: true });
    }

    clearUploadWarnings = () => {
        this.props.actions.clearAlert(this.props.alertView ? `${this.props.alertView}-upload-wrong-file-size` : 'logo-upload-file-size');
        this.props.actions.clearAlert(this.props.alertView ? `${this.props.alertView}-upload-wrong-type` : 'logo-upload-wrong-type');
    }

    clearUpload = () => {
        this.setState({ hasError: false });
    }

    chooseFile = (chooseImageBtn) => {
        chooseImageBtn.click();
    }

    dropImage(incomingData) {
        this.handleChosenFile(incomingData);
    }

    render() {
        return (
            <DragAndDrop
                clearUploading={this.state.hasError}
                clearUploadAction={this.clearUpload}
                data={this.state}
                chooseFile={this.chooseFile}
                handleChosenImage={this.handleChosenImage}
                dropImage={this.dropImage}
                height={this.props.height}
                width={this.props.width}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ImageDropZone));
